var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.authed)?_c('div',[_c('Calendar3',{attrs:{"permissions":_vm.permissions,"showdialog":function (){ return true; },"highlight":function (){ return true; }},on:{"click-order":_vm.onClickOrder}})],1):_c('div',[_vm._v("欢迎")])}
var staticRenderFns = []

export { render, staticRenderFns }